export default __webpack_public_path__ + "static/media/gatheringstorm.5e6d0c5c.jpg";